(function () {
  function getSizeGuideProductId() {
    const popupTrigger = $.magnificPopupT4s?.instance?.st?.el
    const triggerProductId =
      typeof popupTrigger?.attr === 'function'
        ? popupTrigger.attr('data-product-id')
        : popupTrigger?.getAttribute?.('data-product-id')

    return String(triggerProductId || window.meta?.product?.id || '').trim()
  }

  const productId = getSizeGuideProductId()
  const size_info =
    window.product_size_info?.[productId] ||
    window.getProductSizeInfo?.(productId) ||
    window.initSizeInfo?.(productId)
  const metafieldData = size_info?.metafield_data || {}
  const operation_filter = metafieldData.operation_filter
  function init() {
    const product_type = meta.product.type
    const video_map = window.size_guide_video_map?.[product_type]

    function makeVideoCover() {
      // 商品类型
      // 如果没有找到映射，返回空字符串
      if (!video_map?.video) return

      const video_inner = `
        <a
          id="size_guide_video-cover"
          href="#size_guide_video-popup"
          role="button"
          aria-label="Play size guide video"
          style="cursor: pointer; margin-bottom: 10px;"
        >
          <img class="video_cover lazyloadt4s t4s-lz--fadeIn t4s-d-none t4s-d-md-block" data-src="${video_map.cover?.pc}" alt="Size Guide Video Cover" />
          <img class="video_cover lazyloadt4s t4s-lz--fadeIn t4s-d-block t4s-d-md-none" data-src="${video_map.cover?.m}" alt="Size Guide Video Cover" />
        </a>
      `

      $(".mibao_size_guide_2022 .body .size_video_box").html(video_inner)
    }

    function initSizeGuideVideoPopup(videoUrl) {
      const eventNamespace = '.sizeGuideVideo'
      const $document = $(document)
      const $popup = $('#size_guide_video-popup').first()
      const video = $popup.find('#size_guide_video-player').get(0)

      if (!$popup.length || !video || !videoUrl) return

      function closeVideoPopup() {
        video.pause()

        try {
          video.currentTime = 0
        } catch (error) {
          window.report_faro({
            file_name: 'assets/ogl-size-guide.js',
            func_name: 'closeVideoPopup',
            desc: 'Failed to reset size guide video',
            error: error
          })
        }

        $popup.hide().attr('aria-hidden', 'true')
      }

      $document
        .off('click' + eventNamespace, '#size_guide_video-cover')
        .on(
          'click' + eventNamespace,
          '#size_guide_video-cover',
          function (event) {
            event.preventDefault()

            if (video.dataset.src !== videoUrl) {
              video.src = videoUrl
              video.dataset.src = videoUrl
              video.loop = true
              video.load()
            }

            $popup.show().attr('aria-hidden', 'false')

            const playPromise = video.play()
            if (playPromise) {
              playPromise.catch(error => {
                window.report_faro({
                  file_name: 'assets/ogl-size-guide.js',
                  func_name: 'initSizeGuideVideoPopup',
                  desc: 'Failed to play size guide video',
                  error: error
                })
              })
            }

            window.Shopify?.analytics?.publish('auto_tracking', {
              type: 'click',
              element_id: 'size_guide_video-cover_manual'
            })
          }
        )

      $popup
        .off(eventNamespace)
        .on(
          'click' + eventNamespace,
          '.t4s-video-popup-wrapper, #size_guide_video-close',
          function (event) {
            event.preventDefault()
            closeVideoPopup()
          }
        )

      $document
        .off('keydown' + eventNamespace)
        .on('keydown' + eventNamespace, function (event) {
          if (event.key === 'Escape' && $popup.is(':visible')) {
            closeVideoPopup()
          }
        })

      closeVideoPopup()
    }

    makeVideoCover()
    initSizeGuideVideoPopup(video_map?.video)

    function renderAttributes() {
      let attributes_html = ''
      function make_attributes_html(operation_filter) {
        if (!operation_filter) {
          return ''
        }
        const stretchMapping = {
          "excellent stretch": 0,
          "great stretch": 0,
          "medium stretch": 50,
          "slight stretch": 100,
          "non-stretch": 100
        };

        const fitMapping = {
          "oversized fit": 0,
          "relaxed fit": 0,
          "regular fit": 50,
          "fitted": 100,
          "slim fit": 100
        };

        let htmlContent = '';

        // 安全获取并转换为小写，使用 operation_filter
        const currentStretch = operation_filter.stretch_type ? operation_filter.stretch_type.toLowerCase() : "";
        const currentFit = operation_filter.fit_type ? operation_filter.fit_type.toLowerCase() : "";

        // 检查并渲染 Stretchy 模块
        if (currentStretch && stretchMapping[currentStretch] !== undefined) {
          const position = stretchMapping[currentStretch];
          document.querySelector('.attributes-container #stretchy .thumb').style.left = `${position}%`
          document.querySelector('.attributes-container #stretchy').style.display = 'flex'
        }

        // 检查并渲染 Style (Fit) 模块
        if (currentFit && fitMapping[currentFit] !== undefined) {
          const position = fitMapping[currentFit];
          document.querySelector('.attributes-container #style .thumb').style.left = `${position}%`
          document.querySelector('.attributes-container #style').style.display = 'flex'
        }
      }

      attributes_html = make_attributes_html(operation_filter)
    }

    renderAttributes()

    function insertModelInfo() {
      $(".mibao_size_guide_2022 #model_info").html(metafieldData["size_guide_model_data"] || "");
    }
    insertModelInfo()

    if (!size_info.hasProductSize()) {
      // sizeData没数据
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(
        ".mibao_size_guide_2022 .guide_table .header span[type=product]"
      ).addClass("hit");
      $(".mibao_size_guide_2022 .guide_table .header span[type=body").hide();
    }
    $(".mibao_size_guide_2022 .guide_table .switch").click(function (e) {
      const unit = $(this).attr("unit");
      const newUnit = unit == "cm" ? "inch" : "cm";
      $(this).attr("unit", newUnit);
      $(this).find(".name").removeClass("hit");
      $(this).find(`.name.${newUnit}`).addClass("hit");
      makeTable();
    });
    $(".mibao_size_guide_2022 .guide_table .header span").click(function (e) {
      $(".mibao_size_guide_2022 .guide_table .header span").removeClass("hit");
      $(this).addClass("hit");
      makeInfo();
      makeTable();
    });
  }
  function makeInfo() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const product_types = meta.product.type.split(">");
    let info_type;
    if (type == "product") {
      // 上衣tops，连衣裙dress，裤装pants,shorts，半裙skirts，skorts
      if (/tops/i.test(product_types[1])) {
        info_type = "tops";
      } else if (/dresses/i.test(product_types[1])) {
        info_type = "dresses";
      } else if (
        /bottoms/i.test(product_types[1]) &&
        !/skirt/i.test(product_types[2])
      ) {
        info_type = "bottoms";
      } else if (/skirt/i.test(product_types[2])) {
        info_type = "skirts";
      }
    } else if (type == "body") {
      info_type = "body";
    }
    $(".mibao_size_guide_2022 .info").hide();
    if (info_type) {
      $(`.mibao_size_guide_2022 .info.${info_type}`).show();
    }
  }

  function makeTable() {
    const type = $(".mibao_size_guide_2022 .guide_table .header .hit").attr(
      "type"
    );
    const unit = $(".mibao_size_guide_2022 .guide_table .switch").attr("unit");
    $(".mibao_size_guide_2022 .guide_table .switch").show(0);
    let sizeData = [];
    let needResize = true;
    if (type == "body") {
      sizeData = size_info.convertBodySizeTableUnit(unit, false)
      needResize = false;
    } else if (type == "size") {
      sizeData = [
        [
          "<span class='w'>weight<br><sub>(LBS)</sub></span><span class='h'>height</span><b>&nbsp<b>",
          "<100",
          "100",
          "120",
          "130",
          "140",
          "150",
          "160",
          "170",
          "180",
          "190",
          "200",
        ],
        ["5'1''", "XS", "S", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'2''", "XS", "XS", "S", "S", "M", "M", "L", "L", "XL", "XXL", ""],
        ["5'3''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'4''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'5''", "XS", "XS", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'6''", "XS", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'7''", "", "S", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'8''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'9''", "", "", "S", "S", "M", "M", "L", "L", "L", "XL", "XXL"],
        ["5'10''", "", "", "S", "S", "M", "M", "M", "L", "L", "L", "XL"],
        ["5'11''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
        ["6'0''", "", "", "M", "M", "M", "M", "M", "L", "L", "L", "XL"],
      ];
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
    } else if (type == "country") {
      sizeData = size_info.country_size
      needResize = false;
      $(".mibao_size_guide_2022 .guide_table .switch").hide(0);
    }
    //覆盖sizeData,商品尺码表
    function makeTableHtml(sizeData) {
      let tableHtml = "";
      let tableFieldNameHtml = "";
      if (needResize) {
        // 数据转换，行列对调
        const sizeDataResize = [];
        for (let index in sizeData) {
          const line = sizeData[index];

          for (let key in line) {
            if (sizeDataResize[key] == undefined) {
              sizeDataResize[key] = [];
            }
            sizeDataResize[key][index] = line[key] || "&nbsp;";
          }
        }
        sizeData = sizeDataResize;
      }

      // for(let item of sizeData){
      for (let item of sizeData) {
        let tmp = `<tr> <td>${item.slice(1).map(item => {
          return item
        }).join("</td><td>")}</td></tr>`;
        let tmp2 = `<tr><td>${item[0]}</td></tr>`;
        tableHtml += tmp;
        tableFieldNameHtml += tmp2;
      }
      tableHtml = `<div class="data"><table>${tableHtml}</table></div>`;
      tableFieldNameHtml = `<div class="fixed_header"><table>${tableFieldNameHtml}</table></div>`;

      return `<div class="content">${tableFieldNameHtml}${tableHtml}</div>`
    }

    function JoinTables() {
      if (type == "product") {
        return size_info.renderProductSizeTable(unit)
      }

      return `<div class="table-wrapper"> ${makeTableHtml(sizeData)}</div>`
    }

    // 挂载表格
    $(".mibao_size_guide_2022 .guide_table .guide_table_body").html(JoinTables());

    if (type == "size") {
      $(
        ".mibao_size_guide_2022 .guide_table .content .fixed_header table"
      ).addClass("size");
      $(".mibao_size_guide_2022 .guide_table .content .data table").addClass(
        "size"
      );
    }
  }

  // 打开 Size Guide 时默认使用厘米，同步单位状态、按钮高亮和表格数据。
  const $unitSwitch = $(".mibao_size_guide_2022 .guide_table .switch");
  $unitSwitch.attr("unit", "cm");
  $unitSwitch.find(".name").removeClass("hit");
  $unitSwitch.find(".name.cm").addClass("hit");
  makeTable()
  makeInfo()
  MB_jsDeferHandle(init, ["jQuery"]);
})();
